import {
  ADD_PROGRAM_TO_GROUP,
  REVIEW_ADD_PROGRAM_TO_GROUP,
} from '../constants/urls';
import zfetch, { METHOD_POST } from '../pages/common/utils/zfetch';

const reviewAddProgramToGroup = data => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(data),
  };
  return zfetch(REVIEW_ADD_PROGRAM_TO_GROUP, options).then(res => res.json());
};

const addProgramToGroup = data => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(data),
  };
  return zfetch(ADD_PROGRAM_TO_GROUP, options).then(res => res.json());
};

export { reviewAddProgramToGroup, addProgramToGroup };
